import { VFC, ChangeEvent } from "react";
import { Grid, TextField } from "@mui/material";

type Props = {
  name: string;
  type?: string;
  label?: string;
  xs?: number | boolean;
  defaultValue?: string;
  handle?: (e: ChangeEvent<HTMLInputElement>) => void;
  handleKeyDown?: (e: React.KeyboardEvent<HTMLDivElement>) => void;
};

export const FormText: VFC<Props> = (props) => {
  const { name, type, label, xs = 10, handle, handleKeyDown } = props;
  return (
    <Grid item xs={xs}>
      <TextField
        name={name}
        type={type ?? "text"}
        label={label ?? ""}
        fullWidth
        size="small"
        {...(label && { InputLabelProps: { shrink: true } })}
        onChange={handle}
        onKeyDown={handleKeyDown}
      />
    </Grid>
  );
};
